import request from '@/common/request.js'

export function getPromotionRankTop100 () {
  return request.get('/anonymous/promotionRank/top100')
}
